import web3Config from "./web3";

const THIRDWEB_CLIENT_ID = process.env.NEXT_PUBLIC_THIRDWEB_CLIENT_ID;
const ADMIN_ACCOUNT_PRIVATE_KEY = process.env.ADMIN_ACCOUNT_PRIVATE_KEY;
const RPC_URL = process.env.RPC_URL;

const TOKEN_URI_ERC721_ABI = ["function tokenURI(uint256 tokenId) external view returns (string memory)"];

const CONTRACT_ADDRESS = web3Config.contractAddress;
const CONTRACT_ABI = web3Config.abi;
const CHAIN_ID = web3Config.chainId;

const NFT_CONTRACT_ADDRESS = web3Config.nftContractAddress;
const NFT_ABI = web3Config.nftabi;

const RPC_ENDPOINTS = [
  "https://polygon.llamarpc.com",
  "https://polygon-rpc.com",
  "https://rpc-mainnet.matic.network",
  "https://matic-mainnet.chainstacklabs.com",
];

const CONTRACT_CONFIG = {
  address: CONTRACT_ADDRESS,
  abi: CONTRACT_ABI,
  chainId: CHAIN_ID
};

const GAS_CONFIG = {
  estimateMultiplier: 2,
  maxFeeMultiplier: 2,
  maxPriorityFeeGwei: 30
};

const PRICE_CONFIG = {
  MAX_RETRIES: 5,
  ENDPOINTS: [
    "https://api.binance.us/api/v3/ticker/price?symbol=MATICUSDT",
    "https://api.binance.com/api/v3/ticker/price?symbol=MATICUSDT"
  ]
};

const ADMIN_WALLET_ADDRESS = "0x5D2D18E5d2D29466Ba0bc635Eb7565c7aC2181a6";
const OWNER_CHECKER_CONTRACT = "0x1240C3454F0e2D25E16873313481dCBa1F04a9DB";

export default {
  ADMIN_ACCOUNT_PRIVATE_KEY,
  RPC_URL,
  TOKEN_URI_ERC721_ABI,
  CONTRACT_ADDRESS,
  CONTRACT_ABI,
  NFT_CONTRACT_ADDRESS,
  NFT_ABI,
  RPC_ENDPOINTS,
  CONTRACT_CONFIG,
  GAS_CONFIG,
  ADMIN_WALLET_ADDRESS,
  PRICE_CONFIG,
  THIRDWEB_CLIENT_ID,
  OWNER_CHECKER_CONTRACT
};
